import { makeStyles } from '@material-ui/core'
import { Theme } from 'styling/theme'

export const useStyles = makeStyles((theme: Theme) => ({
    showDuration: {
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        fontSize: 34,
        textAlign: 'center',
        color: theme.colors.white,
        margin: 0,
    },
}))
